<template>
  <main class="dashboard">
        <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">{{current_page.name}}</h1>
    </div>
    <div class="text" v-html="current_page.description"></div>

    <div class="card">
      <div class="card-body links">

        <div class="table-responsive">
          <table class="table dict">
            <thead>
            <tr>
              <th scope="col"> №</th>
              <th scope="col" class="mw200 mxw350">Сайт</th>
              <th scope="col">Сбор семантического ядра</th>
              <th scope="col">Техническая оптимизация посадочных страниц</th>
              <th scope="col">Текстовая оптимизация посадочных страниц</th>
              <th scope="col">Работа по увеличению ссылочной массы</th>
              <th scope="col">Дата добавления / изменения</th>
              <th scope="col">Ближайшая дата проверки</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="empty"></tr>
            <template v-for="(object, index) in objects">
              <tr :class="object.edit?'edit':''">
                <td>{{(index + 1) + ((page - 1) * size)}}</td>
                <template v-if="object.edit">
                  <td>
                    <div :class="object.link_error?'form-group--error':''">
                      <label class="d-none">Сайт</label>
                      <input v-focus class="form-control" type="url" v-model="object.link"
                             v-on:keyup="object.link_error = false">
                    </div>
                    <div class="error" v-if="object.link_error">{{object.link_error}}</div>
                  </td>
                  <td>
                    <div :class="object.requests_count_error?'form-group--error':''">
                      <label class="d-none">Сбор семантического ядра</label>
                      <select v-model="object.requests_count" class="form-select">
                        <option v-for="(value, key) in select.requests_count" :value="key">{{value}}
                        </option>
                      </select>
                    </div>
                    <div class="error" v-if="object.requests_count_error">{{object.requests_count_error}}</div>
                  </td>

                  <td>
                    <div :class="object.teh_page_count_error?'form-group--error':''">
                      <label class="d-none">Техническая оптимизация посадочных страниц</label>
                      <select v-model="object.teh_page_count" class="form-select">
                        <option v-for="(value, key) in select.text_page_count" :value="key" :key="key">{{value}}</option>
                      </select>
                    </div>
                    <div class="error" v-if="object.teh_page_count_error">{{object.teh_page_count_error}}</div>
                  </td>
                  <td >
                     <div :class="object.text_page_count_error?'form-group--error':''">
                       <label class="d-none">Текстовая оптимизация посадочных страниц</label>
                      <select v-model="object.text_page_count" class="form-select">
                        <option v-for="(value, key) in select.text_page_count" :value="key" :key="key">{{value}}</option>
                      </select>
                    </div>
                    <div class="error" v-if="object.text_page_count_error">{{object.text_page_count_error}}</div>

                  </td>

                  <td>
                     <div :class="object.mass_error?'form-group--error':''">
                       <label class="d-none">Работа по увеличению ссылочной массы</label>
                      <select v-model="object.mass" class="form-select">
                        <option v-for="(value, key) in select.mass" :value="key" :key="key">{{value}}</option>
                      </select>
                    </div>
                    <div class="error" v-if="object.mass_error">{{object.mass_error}}</div>

                  </td>
                </template>
                <template v-else>
                  <td><a :href="object.link" target="_blank">{{object.link}}</a></td>
                  <td>{{object.get_requests_count_display}}</td>
                  <td>{{object.get_teh_page_count_display}}</td>
                  <td>{{object.get_text_page_count_display}}</td>
                  <td>{{object.get_mass_display}}</td>
                </template>

                <td>{{object.date}}</td>
                <td>{{object.date_check}}</td>
                <td>
                  <a href="" v-if="!object.edit" v-on:click.prevent="object.edit = true;"
                     class="no-wrap"><i class="bi bi-pencil"></i>
                    <small>редактировать</small>
                  </a>
                  <template v-else>
                    <a href="" class="text-success ms-sm-2 no-wrap" v-on:click.prevent="saveNote(object)"><i
                      class="bi bi-check-circle"></i>
                      <small>Сохранить</small>
                    </a> <br>
                    <a href="" class="text-danger ms-sm-2 no-wrap" v-on:click.prevent="endEdit(object)"><i
                      class="bi bi-x-circle"></i>
                      <small>Отмена</small>
                    </a>
                  </template>
                </td>

              </tr>
            </template>
            <tr v-if="!objects.length">
              <td colspan="8">
                Не добавлено ни одной записи
              </td>
            </tr>
            <tr v-if="objects.length < max_length">
              <td colspan="8">
                <button class="btn btn-success" v-on:click="addNote" title="Добавить запись">+</button>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
      <PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page" ></PagerList>


    </div>


  </main>
</template>

<script>
  import dataMixin from './mixins.js';
  export default {
    name: 'SeoService',
    mixins: [dataMixin],
    data() {
      return {
        name: 'seo',
        empty: {
          link: '', requests_count: '', date: '', edit: true, teh_page_count: '', text_page_count: '', mass: ''
        },
        validate: {
          link: {func: (o) => {return !o.link || !this.$func.isURLValid(o.link)}, error: 'Неверный формат ссылки'},
          requests_count: {}, teh_page_count: {}, text_page_count: {}, mass: {}
        },
        select: {
          requests_count: [], text_page_count: [], mass: []
        },
      }
    }

  }

</script>


<style>
  textarea {
    min-width: 380px;
  }

  .form-select {
    min-width: 150px;
  }
</style>
